import Headroom from "headroom.js";
import Macy from "macy/dist/macy.js";

$(function() {

  var myElement = document.querySelector(".site-header");
// construct an instance of Headroom, passing the element
  var headroom  = new Headroom(myElement, {
    offset: 0
  });
  // initialise
  headroom.init();

  const myCustomSlider = document.querySelectorAll('.home-slider');
  for( i=0; i< myCustomSlider.length; i++ ) {
    myCustomSlider[i].classList.add('home-slider-' + i);
    var slider = new Swiper('.home-slider-' + i, {
    /* Options */
      slidesPerView: 1,
      spaceBetween: 0,
      direction: 'horizontal',
      watchOverflow: true,
      lazy: true,
      autoplay: {
        delay: 5000,
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      // Navigation arrows
      navigation: {
        nextEl: '.home-slider-' + i + ' .swiper-button-forward',
        prevEl: '.home-slider-' + i + ' .swiper-button-back',
      },
    });
  }


$('.js-load-more').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[loader]').removeClass('hide');
  currentPage = currentPage+1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.tw-grid').append($(responseHTML).find('.tw-grid').html());
    },
    complete: function() {
      if(currentPage <= totalPages) {
         $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
      }
    }
  })
});

if (document.body.classList.contains('template-blog')) {
    var macy_instance = Macy({
      container: '#macy-container',
      trueOrder: true,
      waitForImages: true,
      margin: 0,
      columns: 3,
      margin: {
        x: 32,
        y: 32
      },
      breakAt: {
          1200: 3,
          940: 2,
          520: 1
      }
  });

  macy_instance.runOnImageLoad(() => {
    macy_instance.recalculate();
  }, true);
};


$('.collectionSlider').each(function(){
  var collectionswiper = new Swiper('.swiper-collection', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,

      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 0
        },
        960: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      },

      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },

      navigation: {
        nextEl: '.swiper-button-forward',
        prevEl: '.swiper-button-back',
      },

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
  });
});


  // scrollreveal
  // var animateSequence = document.querySelectorAll('.animate-left');
  // var animateSequenceDown = document.querySelectorAll('.animate-down');
  var animateSequenceUp = document.querySelectorAll('.animate-up');

  var animateSequence = document.querySelectorAll('.animate-down');

  var animateSequenceLeft = document.querySelectorAll('.animate-left');
  var animateSequenceRight = document.querySelectorAll('.animate-right');


  ScrollReveal().reveal(animateSequenceLeft, {
    origin: "left",
    distance: "250px",
    delay: 100,
    duration: 750,
    viewFactor: 0.2,
    reset: false,
    mobile: false,
});
  ScrollReveal().reveal(animateSequenceRight, {
    origin: "right",
    distance: "250px",
    delay: 100,
    duration: 750,
    viewFactor: 0.2,
    reset: false,
    mobile: false,
});

  ScrollReveal().reveal(animateSequence, {
      origin: "up",
      distance: "50px",
      interval: 250,
      reset: false,
      mobile: false,
  });

  // ScrollReveal().reveal(animateSequenceDown, {
  //     origin: "bottom",
  //     distance: "50px",
  //     interval: 250,
  //     reset: false,
  //     mobile: false,
  // });
});
